import { useDeepCompareMemo } from 'use-deep-compare';
import { useBlueberrySizeData } from './useBlueberrySizeData';

export const useBlueberrySizeChartData = () => {
  const { dataset, ...restOfResult } = useBlueberrySizeData();

  const filteredDataset = useDeepCompareMemo(() => {
    // Filter out the unknown size bucket
    const filteredDataset = dataset.filter((row) => row.size !== 'unknown');
    return filteredDataset;
  }, [dataset]);

  return { dataset: filteredDataset, ...restOfResult };
};
